import { render, staticRenderFns } from "./signAccount.vue?vue&type=template&id=72ec1e27&scoped=true"
import script from "./signAccount.vue?vue&type=script&lang=js"
export * from "./signAccount.vue?vue&type=script&lang=js"
import style0 from "./signAccount.vue?vue&type=style&index=0&id=72ec1e27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ec1e27",
  null
  
)

export default component.exports